import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import ReceiptPage from "./components/Receipt";
import { ThemeProvider } from "./context/ThemeContext";
import SalesList from "./pages/SalesList";
import Settings from "./pages/Settings";
import Invoice from "./pages/Invoice";
import InvoiceDetail from "./pages/InvoiceDetail";
import UpdatePosInvoice from "./pages/UpdatePosInvoice";

function App() {
    return (
        <ThemeProvider>
            <Router>
                <ToastContainer 
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/dashboard" element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    } />
                    <Route path="/receipt/:sale_id" element={
                        <PrivateRoute>
                            <ReceiptPage />
                        </PrivateRoute>
                    } />
                    <Route path="/sales" element={
                        <PrivateRoute>
                            <SalesList />
                        </PrivateRoute>
                    } />
                    <Route path="/settings" element={
                        <PrivateRoute>
                            <Settings />
                        </PrivateRoute>
                    } />
                    <Route path="/invoice" element={
                        <PrivateRoute>
                            <Invoice />
                        </PrivateRoute>
                    } />
                    <Route path="/invoice/:invoice_id" element={
                        <PrivateRoute>
                            <InvoiceDetail /> 
                        </PrivateRoute>
                        } />

                    <Route path="/update-pos-invoice/:invoice_id" element={
                        <PrivateRoute>
                            <UpdatePosInvoice />
                        </PrivateRoute>
                        } />

                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
}

export default App;